import Navbar from "./components/Navbar";
import Home from "./components/Home";
import "./App.css";
import Inventory from "./components/Inventory";
import Places from "./components/Places";
import Thanks from "./components/Thanks";
import Contact from "./components/Contact";
import Details from "./components/Details";

function App() {
  return (
    <>
      <Navbar />
      <section id="home">
        <Home />
      </section>
      <section id="details">
        < Details />
      </section>
      <section id="inventory">
        < Inventory />
      </section>
      <section id="places">
        <Places />
      </section>
      <section id="thanks">
        < Thanks />
      </section>
      <section id="contact">
        <Contact />
      </section>

    </>
  );
}

export default App;